import { useContext } from 'react'
import GroupContext from '../GroupContext'

const useGroupContext = (component, force = true) => {
  const context = useContext(GroupContext)
  if (force && !context) {
    const err = new Error(`<${component} /> is missing GroupContext`)
    if (Error.captureStackTrace) Error.captureStackTrace(err, useGroupContext)
    throw err
  }
  return context
}

export default useGroupContext
